import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	ManpowerWorkersApiService,
	AddWorkerBody,
	UpdateWorkerBody,
	SetSalaryBody,
} from '../../../services/manpowerWorkersApi';

const LIST_KEY = ['manpower', 'workers', 'listing'];

/**
 * Worker mutations: add-to-vendor (mapping), update, and set salary card.
 * Worker-list mutations invalidate the list; salary invalidates that worker's salary query.
 */
export const useWorkerMutations = () => {
	const queryClient = useQueryClient();
	const invalidateList = () => queryClient.invalidateQueries({ queryKey: LIST_KEY });

	const addToVendor = useMutation({
		mutationFn: ({ vendorId, body }: { vendorId: number; body: AddWorkerBody }) =>
			ManpowerWorkersApiService.addWorkerToVendor(vendorId, body),
		onSuccess: invalidateList,
	});

	const update = useMutation({
		mutationFn: ({ id, body }: { id: number; body: UpdateWorkerBody }) =>
			ManpowerWorkersApiService.updateWorker(id, body),
		onSuccess: invalidateList,
	});

	const setSalary = useMutation({
		mutationFn: ({ workerId, body }: { workerId: number; body: SetSalaryBody }) =>
			ManpowerWorkersApiService.setSalary(workerId, body),
		onSuccess: (_data, vars) =>
			queryClient.invalidateQueries({ queryKey: ['manpower', 'workers', 'salary', vars.workerId] }),
	});

	return { addToVendor, update, setSalary };
};
